import styled from 'styled-components';

export const ThankYouCardAtom = styled.div<{ padding?: string }>`
  background-color: white;
  border-radius: 0.75rem;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: ${(props) => props.padding || '1.5rem'};
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    padding: ${(props) => props.padding || '1.25rem'};
    margin-bottom: 1rem;
  }
`;